module.exports = __webpack_public_path__ + "img/D-CIPHER-A_logo.4dca7162.svg";